import { Provider } from '@angular/core';
import { LAYOUT_THEME } from '@shared/di/layout-theme.token';
import { PAGE } from '@shared/di/page.token';
import { LayoutService } from './services/app.layout.service';
import { PageService } from './services/app.page.service';

/** Binds the shared page shell to {@link PageService}. Register at the root injector. */
export function providePage(): Provider {
  return { provide: PAGE, useExisting: PageService };
}

/** Binds the shared theme gate to {@link LayoutService}. Register at the root injector. */
export function provideLayoutTheme(): Provider {
  return { provide: LAYOUT_THEME, useExisting: LayoutService };
}
